import { Component, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fahrzeug-list-view',
  imports: [],
  templateUrl: './fahrzeug.list-view.html',
  styleUrls: ['./fahrzeug.list-view.css'],
})
export class FahrzeugListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
